import React, { Component } from "react";
import classnames from "classnames";
import styles from "./IndicatorsExplanation.local.scss";
import _ from "i18n";
import Select from "react-select";

class IndicatorExplanationUpdateSideBar extends Component {
  render() {
    const {
      saving,
      isUpdatingExplanation,
      explanations,
      indicators
    } = this.props;
    return (
      <div
        className={classnames(
          styles.sidebar,
          isUpdatingExplanation ? styles.display : ""
        )}
      >
        <img
          src={"/img/icons/close.svg"}
          className={styles.sidebar__close}
          onClick={() => this.props.onCancelUpdateExplanation()}
          alt={""}
        />

        <div className={styles.sidebar__titles}>
          <h4>{_("updateExplanation")}</h4>
          <h5>{_("typeExplanations")}</h5>
        </div>

        <div className={styles.indicators_block}>
          <span className={styles.span_label}>{_("indicator")}</span>
          <Select
            value={
              this.props.selectedAccount &&
              indicators.find(
                obj => obj.value === this.props.selectedAccount.value
              )
            }
            isDisabled={true}
            onChange={this.props.onChangeSelectedAccount}
            options={indicators}
            className={"indicators_new"}
            classNamePrefix="ttp-select"
            isClearable={true}
            placeholder={"Comptes et indicateurs..."}
            menuPlacement="auto"
          />
        </div>

        <div className={styles.labels_form_block}>
          <span className={styles.span_label}>
            <img src={"/img/icons/fr_flag.png"} alt={""} width={22} />
            {_("French")}
          </span>
          <div className={styles.div_input}>
            <input
              type={"text"}
              placeholder={_("frExplanation")}
              value={explanations.fr}
              onChange={e => this.props.onChangeExplanationFr(e)}
              required={true}
            />
            <img src={"/img/icons/pencil.svg"} alt={""} />
          </div>
          <span className={styles.span_label}>
            <img src={"/img/icons/en_flag.png"} alt={""} width={22} />
            {_("English")}
          </span>
          <div className={styles.div_input}>
            <input
              type={"text"}
              placeholder={_("enExplanation")}
              value={explanations.en}
              onChange={e => this.props.onChangeExplanationEn(e)}
              required={true}
            />
            <img src={"/img/icons/pencil.svg"} alt={""} />
          </div>
          <span className={styles.span_label}>
            <img src={"/img/icons/nl_flag.png"} alt={""} width={22} />
            {_("Dutch")}
          </span>
          <div className={styles.div_input}>
            <input
              type={"text"}
              placeholder={_("nlExplanation")}
              value={explanations.nl}
              onChange={e => this.props.onChangeExplanationNl(e)}
              required={true}
            />
            <img src={"/img/icons/pencil.svg"} alt={""} />
          </div>
        </div>

        <div className={styles.actions_block}>
          <button
            className={styles.cancel_btn}
            onClick={() => this.props.onCancelUpdateExplanation()}
          >
            {_("cancel")}
          </button>
          <button
            disabled={
              this.props.selectedAccount &&
              (explanations.fr !== "" ||
                explanations.en !== "" ||
                explanations.nl !== "")
                ? false
                : true
            }
            className={styles.save_button}
            onClick={() =>
              this.props.handleUpdateExplanation(this.props.explanationId)
            }
          >
            <img
              src={"/img/icons/tail-spin.svg"}
              alt={""}
              className={saving ? styles.loading : ""}
            />
            {_("update")}
          </button>
        </div>
      </div>
    );
  }
}

export default IndicatorExplanationUpdateSideBar;



// WEBPACK FOOTER //
// ./src/components/IndicatorsExplanation/IndicatorExplanationUpdateSideBar.js